const DefaultTheme = {
    backgroundColor: '#2C3E50',
    accentColor: '#F6A623'
}

export default DefaultTheme



// WEBPACK FOOTER //
// ./src/utils/themes/default.js